// Membaca runtime config dari conf.js (override deployment) atau import.meta.env (build time)
const runtimeEnv = (window as Window & { __ENV__?: Record<string, string> }).__ENV__ ?? {};

function cfg(key: string, fallback = ''): string {
  return runtimeEnv[key] || (import.meta.env[key] as string) || fallback;
}

function cfgBool(key: string, fallback = false): boolean {
  const value = cfg(key);
  if (value === 'true') return true;
  if (value === 'false') return false;
  return fallback;
}

export const env = {
  appName: 'App React',
  environment: import.meta.env.MODE,
  queryDebug: cfgBool('VITE_QUERY_DEBUG', true),

  // Auth Method Configuration
  authMethod: cfg('VITE_AUTH_METHOD', 'alurkerja_sso'), // 'keycloak' or 'alurkerja_sso'

  apiTasklistBaseUrl: cfg('VITE_API_TASKLIST_BASEURL', 'https://tasklist2.minipc.javan.id'),
  cloudStorage: cfg('VITE_MINIO_CLOUD', 'https://minio.merapi.javan.id'),
  micrositeUrl: cfg('VITE_MICROSITE_URL', 'https://org.saas.merapi.alurkerja.com'),
  contactUrl: cfg('VITE_CONTACT_URL', 'https://alurkerja.com/contact'),

  // Keycloak Configuration
  keycloakUrl: cfg('VITE_KEYCLOAK_URL', 'https://keycloak.merapi.javan.id'),
  keycloakRealm: cfg('VITE_KEYCLOAK_REALM', 'internal'),
  keycloakClientId: cfg('VITE_KEYCLOAK_CLIENT_ID', 'joglo'),
  keycloakClientSecret: cfg('VITE_KEYCLOAK_CLIENT_SECRET'),
  keycloakRedirectUri: cfg('VITE_KEYCLOAK_REDIRECT_URI') || globalThis.location.origin + '/callback',

  sentryDsn: cfg('VITE_SENTRY_DSN'),

  // AlurKerja SSO Configuration
  AK_CLIENT_ID: cfg('VITE_AK_CLIENT_ID', '3'),
  AK_CLIENT_SECRET: cfg('VITE_AK_CLIENT_SECRET'),
  AK_REDIRECT_URI: cfg('VITE_AK_REDIRECT_URI') || globalThis.location.origin + '/callback',

  IS_SETTING_ENABLED: cfg('VITE_PRODUCTION') !== 'true',
  STUDIO_URL: cfg('VITE_STUDIO_URL', 'https://studio-onprem.merapi.alurkerja.com'),
  APP_URL: cfg('VITE_APP_URL', 'https://app-onprem.merapi.alurkerja.com'),
  COMPRO_URL: cfg('VITE_COMPRO_URL', 'https://compro-onprem.merapi.alurkerja.com'),
};